








import { defineComponent, onMounted, onActivated, onDeactivated, ref, Ref } from '@vue/composition-api';

export default defineComponent({
  name: 'ParallaxContainer',
  props: {
    startPos: {
      type: String,
      default: '100px',
    },
    endPos: {
      type: String,
      default: '-100px',
    },
  },
  setup(props) {
    // Refs
    const parallax: Ref<HTMLDivElement | null> = ref(null);
    const fixed: Ref<HTMLDivElement | null> = ref(null);

    const anim: Ref<Animation | null> = ref(null);

    function updatePosition() {
      // TODO could be customized via e.g. props
      // TODO optimize reflow/dom-relayout...
      // normalized position (0..1) where 0 is returned if the top edge of the container enters the viewport and 1 is returned if the bottom edge leaves the viewport
      const { top, height } = (fixed.value as HTMLDivElement).getBoundingClientRect();
      const pos = Math.max(0, Math.min(1, 1 - (top + height) / (window.innerHeight + height)));

      // this value is set in the mounted lifecycle hook
      const a = anim.value as Animation;
      if (a.currentTime !== pos) {
        a.currentTime = pos;
      }
    }

    onMounted(() => {
      const pElem = (parallax.value as unknown) as HTMLDivElement; // typescript issues...
      anim.value = pElem.animate(
        {
          transform: [`translateY(${props.startPos})`, `translateY(${props.endPos})`],
        },
        { duration: 1 }
      );
      anim.value.pause();
      updatePosition();
    });

    // TODO make this customizable in the future (currently it's hardcoded as the root component of the app)
    onActivated(() => document.querySelectorAll('.view').forEach((e) => e.addEventListener('scroll', () => updatePosition())));
    onDeactivated(() => document.querySelectorAll('.view').forEach((e) => e.removeEventListener('scroll', () => updatePosition())));
    return {
      parallax,
      fixed,
      updatePosition,
    };
  },
});
